
import { AccountEffects } from './account.effects';
import { AddressEffects } from './address.effects';
import { AuthEffects } from './auth.effects';
import { EncodingEffects } from './encoding.effects';
import { SharedEffects } from './shared.effects';
import { DatabaseEffects } from './database.effects';
export const effects: any[] = [
    AccountEffects,
    AuthEffects,
    SharedEffects,
    EncodingEffects,
    AddressEffects,
    DatabaseEffects
];
